import React, {useState, useEffect, Component} from 'react';
import {View, Text} from 'react-native';
import Requests from '../api/Requests';
import {TableContainer} from '../components/table/Table';
import styled, {css} from 'styled-components/native';
import {colours, spacing} from '../styles/Style';
import {
  GetGlobalTheme,
  DataTypes,
  WindowTypes,
  IsHRWeb,
  GetParameterID,
  GetDefaultBackBehaviour,
  WindowWrap,
  GetApprovalStatusText,
  IsHRiOS,
  goBack,
  DoNavigate,
  IsManager,
  ScreenHeight,
  ScreenWidth,
  UsePagination,
  ResetRecord,
} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import {InspectWindow} from '../components/edit_elements/InspectWindow';
import EditField from '../components/edit_elements/EditField';
import {translate} from '../Tools/LanguageTools';
import {SetCurrentWindow2, AddDateFilter} from '../Tools/WindowTools';
import {Modal} from 'react-native';
import {YesNoWindow} from '../components/status/YesNoWindow';
import EmpTimeTable from '../components/status/EmpTimeTable';
import {RecordColumns, BrowseColumns} from './Columns/VacPlansColumns';
import {b64toBlob} from '../Tools/Base64Decode';
import {createDrawerNavigator} from '@react-navigation/drawer';
import {FixRecordMissingFields} from '../Tools/RecordTools';

const kDefPerPage = 20;
const Drawer = createDrawerNavigator();

let FilterView;
if (IsHRWeb()) {
  FilterView = styled.View`
    position: absolute;
    top: 100%;
    right: 0px;
    width: 340px;
    background: ${colours[GetGlobalTheme()].lightBackground};
    padding: 20px;
    flex-direction: column;
    align-items: center;
  `;
} else {
  if (IsHRiOS()) {
    FilterView = styled.View`
      position: absolute;
      height: ${ScreenHeight()};
      width: ${ScreenWidth()};
      background: ${colours[GetGlobalTheme()].lightBackground};
      padding: 6px;
    `;
  } else {
    FilterView = styled.Modal``;
  }
}

const VacationInfo = styled.View`
  padding: ${spacing.small300}px;
`;
const VacationInfoText = styled.Text`
  margin-bottom: 10px;
`;

const FilterViewInner = styled.View`
  ${IsHRWeb() == false &&
  css`
    height: 100%;
    width: 100%;
    background-color: ${colours[GetGlobalTheme()].siteBackground};
  `};
  ${IsHRiOS() &&
  css`
    padding-top: 50;
  `};
`;

const FilterFields = styled.View`
  ${IsHRWeb() &&
  css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    /*margin-right: -30px;*/
    width: 100%;
  `}
`;
const FilterField = styled.View`
  ${IsHRWeb() &&
  css`
    /*margin-right: 30px;*/
  `}
`;
const FilterActions = styled.View`
  display: flex;
  ${(IsHRWeb() &&
    css`
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-end;
    `) ||
  css`
    flex-direction: column-reverse;
  `}
`;

class VacPlansList extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.createNewVacPlan = this.createNewVacPlan.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.renderNewButton = this.renderNewButton.bind(this);
    //this.changePage = this.changePage.bind(this);
    this._isMounted = true;
    this.table = 18;
    this.ScreenName = 'VacPlans';
    this.init = true;
    this.state = {
      data: [],
      record: {},
      show: false,
      newVacPlanHelper: false,
      NewEmp: '',
      NewGroup: '',
      px: 0,
      py: 0,
      NewStartDate: '',
      NewEndDate: '',
      NewEmpVacDays: [],
      update: false,
    };
    if (global.userData.provider == 0) {
      this.state.NewEmp = global.userData.contractnr;
    }
    this.navigation = props.navigation;
    SetCurrentWindow2('VacPlans', 'SerNr', 'descending');
    AddDateFilter('VacPlans');
    //    this.setState({update: true})
    //this.displayBrowseList();
  }
  getBrowseListData = () => {
    let self = this;
    Requests.getTableData(this.table, undefined, undefined, undefined, true)
      .then((response) => {
        if (self._isMounted) {
          self.setState({data: response.records});
        }
      })
      .catch((error) => {});
  };
  displayBrowseList = () => {
    this.state.WindowType = WindowTypes.Browse;
    this.getBrowseListData();
  };
  rowClick = (id) => {
    DoNavigate(this, 'VacPlans', true, id);
  };
  CheckNewPlanData = () => {
    let res = true;
    if (this.state.NewStartDate == '') {
      res = false;
    }
    if (this.state.NewEndDate == '') {
      res = false;
    }
    if (this.state.NewEmp == '') {
      res = false;
    }
    if (this.state.NewGroup == '') {
      res = false;
    }
    return res;
  };

  createNewVacPlan = () => {
    let self = this;
    let tdata;
    if (this.CheckNewPlanData() == false) {
      global.messageBox({
        showMessage: true,
        statusMessage: translate('FillMandFields'),
      });
      return;
    }
    if (global.userData.provider == 0) {
      tdata = {
        record: {
          ContractNr: this.state.NewEmp,
          OffWorkGr: this.state.NewGroup,
          StartDate: this.state.NewStartDate,
          EndDate: this.state.NewEndDate,
        },
      };
    } else {
      tdata = {
        record: {
          rows: [
            {
              ContrSerNr: this.state.NewEmp,
              AbsTypeCode: this.state.NewGroup,
              StartDate1: this.state.NewStartDate,
              EndDate1: this.state.NewEndDate,
            },
          ],
        },
      };
    }
    Requests.getNewRecord(this.table, tdata)
      .then((response) => {
        if (response.hasOwnProperty('record')) {
          if (global.userData.provider == 0) {
            self.state.NewEmp = global.userData.contractnr;
          } else {
            self.state.NewEmp = '';
          }
          self.state.NewGroup = '';
          self.state.NewStartDate = '';
          self.state.NewEndDate = '';
          self.ShowHideNewVacPlan();
          if (UsePagination() == false) {
            self.getBrowseListData();
          }
          self.rowClick(response.record.SerNr);
        }
      })
      .catch((error) => {});
  };

  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidMount() {
    let self = this;
    this.focusSubscription = this.props.navigation.addListener('focus', () => {
      SetCurrentWindow2('VacPlans', 'SerNr', 'descending');
      if (UsePagination() == false) {
        self.getBrowseListData();
      } else {
        if (self.init == false) {
          self.setState({update: self.state.update ? false : true});
        }
        self.init = false;
      }
    });
  }

  ShowHideNewVacPlan = () => {
    if (this.state.newVacPlanHelper) {
      global.PopEscapeActions();
      this.setState({newVacPlanHelper: false});
    } else {
      this.setState({newVacPlanHelper: true});
      global.PushEscapeActions(() => this.ShowHideNewVacPlan());
    }
  };
  checkVacationDays = () => {
    let self = this;
    let foundf = false;
    if (
      this.state.NewGroup != '' &&
      this.state.NewStartDate != '' &&
      this.state.NewEndDate != '' &&
      this.state.NewEmp != ''
    ) {
      this.state.NewGroup = this.state.NewGroup.toUpperCase();
      let group = global.pasteSpecialsVector['19_2'][this.state.NewGroup];
      if (group && (group.UpdateVac == '1' || group.UpdateVac2 == '1')) {
        foundf = true;
        Requests.doAction(
          'calculateoffwork',
          {},
          {
            sd: this.state.NewStartDate,
            ed: this.state.NewEndDate,
            offempcode: this.state.NewEmp,
            group: this.state.NewGroup,
          }
        )
          .then((response) => {
            let tmp = [];
            tmp.push(
              <VacationInfo>
                <VacationInfoText>
                  {translate('VacationDaysonDate') +
                    this.state.NewStartDate +
                    ': ' +
                    response.record.vacdays}
                </VacationInfoText>
                <VacationInfoText>
                  {translate('VacationDays') + response.record.useddays}
                </VacationInfoText>
              </VacationInfo>
            );
            self.setState({NewEmpVacDays: tmp});
          })
          .catch((error) => {});
      }
    }
    if (foundf == false) {
      this.setState({NewEmpVacDays: []});
    }
  };
  renderNewButton = () => {
    let self = this;
    let style = {};
    if (IsHRWeb()) {
      style = {marginRight: '20px'};
    }
    let style2 = {};
    if (IsHRiOS()) {
      style2 = {
        left: -this.state.px,
        top: -this.state.py,
      };
    }
    return (
      <View
        key={'vacplans_new'}
        style={{flexDirection: 'row'}}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          self.setState({py: layout.y, px: layout.x});
        }}
      >
        {IsHRWeb() && global.userData.provider == 0 && (
          <ActionButton
            onPress={() =>
              DoNavigate(self, 'VacPlans', false, '', true, false, 'EmpPlan')
            }
            style={{marginRight: '0px'}}
            title={translate('ShowTimePlan')}
          />
        )}
        <ActionButton
          onPress={() => this.ShowHideNewVacPlan()}
          title={translate('AddNew')}
        />
        {this.state.newVacPlanHelper && (
          <FilterView style={style2}>
            <FilterViewInner>
              <FilterFields>
                <FilterField>
                  <EditField
                    title={translate('StartDate') + '*'}
                    name={'StartDate'}
                    value={this.state.NewStartDate}
                    editable={true}
                    width={'150px'}
                    type={DataTypes.kInputTypeDate}
                    onChange={(index, fn, value) =>
                      self.setState({NewStartDate: value}, () => {
                        self.checkVacationDays();
                      })
                    }
                  />
                </FilterField>
                <FilterField>
                  <EditField
                    title={translate('EndDate') + '*'}
                    name={'EndDate'}
                    value={this.state.NewEndDate}
                    editable={true}
                    width={'150px'}
                    record={{StartDate: this.state.NewStartDate}}
                    linkedfield={'StartDate'}
                    type={DataTypes.kInputTypeDate}
                    onChange={(index, fn, value) =>
                      self.setState({NewEndDate: value}, () => {
                        self.checkVacationDays();
                      })
                    }
                  />
                </FilterField>
                <FilterField style={{width: '100%'}}>
                  {global.userData.provider == 1 && (
                    <EditField
                      title={translate('Contract') + '*'}
                      name={'EmpCode'}
                      value={this.state.NewEmp}
                      ps={1}
                      editable={IsManager()}
                      psheader={[
                        {
                          name: translate('SerNr'),
                          width: '35%',
                          key: 'contractnr',
                        },
                        {
                          width: '35%',
                          name: translate('Name'),
                          key: 'Firstname',
                        },
                        {
                          width: '30%',
                          name: '',
                          key: 'Surname',
                        },
                      ]}
                      onChange={(index, fn, value) =>
                        self.setState({NewEmp: value}, () => {
                          self.checkVacationDays();
                        })
                      }
                    />
                  )}
                  {global.userData.provider == 0 && (
                    <EditField
                      title={translate('Contract') + '*'}
                      name={'EmpCode'}
                      value={this.state.NewEmp}
                      ps={1}
                      editable={true}
                      psheader={[
                        {
                          name: translate('Code'),
                          width: '35%',
                          key: 'contractnr',
                          mainkey: 'ContractNr',
                        },
                        {
                          width: '65%',
                          name: translate('Name'),
                          key: 'empname',
                        },
                      ]}
                      onChange={(index, fn, value) =>
                        self.setState({NewEmp: value}, () => {
                          self.checkVacationDays();
                        })
                      }
                    />
                  )}
                </FilterField>
                <FilterField style={{width: '100%'}}>
                  <EditField
                    title={translate('OffWorkGroup') + '*'}
                    name={'OffWorkGr'}
                    value={this.state.NewGroup}
                    ps={19}
                    psheader={[
                      {
                        name: translate('Code'),
                        width: '35%',
                        key: 'Code',
                        mainkey: 'Code',
                      },
                      {
                        width: '65%',
                        name: translate('Name'),
                        key:
                          global.userData.provider == 0
                            ? 'Description'
                            : 'Name',
                      },
                    ]}
                    onChange={(index, fn, value) =>
                      self.setState({NewGroup: value}, () => {
                        self.checkVacationDays();
                      })
                    }
                  />
                </FilterField>
              </FilterFields>
              <FilterActions>
                <ActionButton
                  style={style}
                  onPress={() => this.ShowHideNewVacPlan()}
                  title={translate('Cancel')}
                />
                <ActionButton
                  onPress={() => this.createNewVacPlan()}
                  title={translate('Create')}
                />
              </FilterActions>
              {this.state.NewEmpVacDays}
            </FilterViewInner>
          </FilterView>
        )}
      </View>
    );
  };
  render() {
    let self = this;
    console.log('render ' + this.state.update);
    return (
      <WindowWrap>
        <TableContainer
          table={this.table}
          update={this.state.update}
          data={this.state.data}
          columns={BrowseColumns(this)}
          doClick={self.rowClick}
          rowID={'sernr'}
          title={translate(this.ScreenName)}
          width="900px"
          extraContent={this.renderNewButton}
        />
      </WindowWrap>
    );
  }
}

class VacPlansRecord extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateRecordField = this.updateRecordField.bind(this);
    this.updateRecordFieldRow = this.updateRecordFieldRow.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.cancelApproval = this.cancelApproval.bind(this);
    this._isMounted = true;
    this.table = 18;
    this.ScreenName = 'VacPlans';
    this.state = {
      data: [],
      record: {},
      show: false,
      message: [],
      WindowType: WindowTypes.Browse,
      hasapprovals: -1,
      NewEmpVacDays: [],
      ApprovalStatus: '',
      ApprovalStatusText: '',
    };
    if (global.userData.provider == 0) {
      this.state.NewEmp = ''; //global.userData.empcode;
    }
    this.navigation = props.navigation;
    if (props.route.params?.id) {
      this.state.ActiveID = props.route.params.id;
      this.rowClick(props.route.params.id);
    }
  }
  rowClick = (id) => {
    let self = this;
    this.state.WindowType = WindowTypes.Inspect;
    this.state.hasapprovals = -1;
    this.setState({record: {}});
    Requests.getTableData(this.table, {SerNr: id}, undefined, undefined, true)
      .then((response) => {
        self.setState({
          id: response.records[0]['SerNr'],
          record: response.records[0],
        });
      })
      .catch((error) => {});
  };
  updateRecordField = (rowindex, index, value) => {
    let self = this;
    /*
    if (rowindex > -1) {
      this.state.record.rows[rowindex][index] = value;
    } else {
      this.state.record[index] = value;
    }
*/
    Requests.updateRecordData(this.table, {
      field: index,
      rownr: rowindex,
      value: value,
      id: this.state.record.SerNr,
    })
      .then((response) => {
        if (response.success) {
          if (self._isMounted) {
            self.state.record = {};
            let record = FixRecordMissingFields(
              response.record,
              RecordColumns(this)
            );
            self.setState({record: record});
            if (index == 'OffWorkGr') {
              self.state.hasapprovals = -1;
              self.CanUseApprovalRules();
            }
          }
        } else {
          if (self._isMounted) {
            ResetRecord(self, index, rowindex, value);
          }
        }
      })
      .catch((error) => {});
  };
  updateRecordFieldRow = (rowindex, index, value) => {
    this.updateRecordField(0, index, value);
  };
  handleInputChange = (rowindex, index, event) => {
    this.updateRecordField(rowindex, index, event.target.value);
  };

  CanUseApprovalRules = () => {
    let self = this;
    let res = this.state.hasapprovals;
    if (
      this.state.record.SerNr !== undefined &&
      this.state.record.SerNr != ''
    ) {
      if (this.state.hasapprovals == -1) {
        this.state.hasapprovals = 0;
        Requests.doAction('checkapprovalstatus', {
          id: this.state.record.SerNr,
          regname: this.table,
        })
          .then((response) => {
            if (response.record.hasapprovals == '1') {
              self.state.ApprovalStatusText = GetApprovalStatusText(
                response.record.approvalstatus
              );
              self.state.ApprovalStatus = response.record.approvalstatus;
              self.state.cancancel = response.record.cancancel;
              self.setState({hasapprovals: 1});
            }
            if (response.record.message != '') {
              let message = response.record.message.split2(':');

              self.setState({message: message});
            }
          })
          .catch((error) => {});
      }
    }
    return res;
  };
  cancelApproval = () => {
    let self = this;
    Requests.doAction('cancelapproval', {
      id: this.state.record.SerNr,
      regname: this.table,
    })
      .then((response) => {
        self.rowClick(self.state.record.SerNr);
      })
      .catch((error) => {});
  };

  RequestApproval = () => {
    let self = this;
    this.state.hasapprovals = -1;
    Requests.doAction('sendforapproval', {
      id: this.state.record.SerNr,
      regname: this.table,
    })
      .then((response) => {
        self.state.hasapprovals = -1;
        self.CanUseApprovalRules();
      })
      .catch((error) => {});
  };

  createOrderDoc = () => {
    let self = this;
    Requests.doAction('orderdocfromoffworkplan', {id: this.state.record.SerNr})
      .then((response) => {
        if (response.newid != '') {
          DoNavigate(self, 'Orders', true, response.newid);
        }
      })
      .catch((error) => {});
  };

  componentDidMount() {}
  componentDidUpdate() {
    let param_id = GetParameterID(this);
    if (this.state.ActiveID != param_id && param_id != '') {
      this.state.ActiveID = param_id;
      this.rowClick(this.state.ActiveID);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  deleteRecord = () => {
    let self = this;
    this.setState({activeDelete: false});
    Requests.deleteRecord(this.table, this.state.record.SerNr)
      .then((response) => {
        self.state.ActiveID = '';
        DoNavigate(self, 'VacPlans', false, '', true, true);
      })
      .catch((error) => {});
  };
  downloadDocument = () => {
    /*application/octet-stream*/
    let self = this;
    //window.open('about:blank', 'Downloading');
    Requests.downloadDocument(this.table, {id: this.state.record.SerNr})
      .then((response) => {
        if (response.file !== '') {
          let blob = b64toBlob(response.file, 'application/pdf');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          // the filename you want
          //a.download = response.name;
          //  a.target = '_blank';
          document.body.appendChild(a);
          window.open(url, 'Downloading');
          //window.URL.revokeObjectURL(url);
        } else {
          global.messageBox({
            showMessage: true,
            statusMessage: translate('DocumentNotFound'),
          });
        }
      })
      .catch((error) => {});
  };

  render() {
    let self = this;
    return (
      <WindowWrap>
        <InspectWindow
          title={translate('VacPlan')}
          window={this}
          headerfields={RecordColumns(this)}
          record={this.state.record}
          onClick={this.handleInputClick}
          allowDelete={true}
          allowPrint={IsHRWeb()}
          hasApprovals={this.state.hasapprovals == 1}
          okcheck={'Status'}
          backButton={() => goBack(self, self.ScreenName)}
        />
        {this.state.activeDelete && (
          <Modal transparent={true}>
            <YesNoWindow
              question={translate('RemoveQuestion')}
              yes={() => this.deleteRecord()}
              no={() => this.setState({activeDelete: false})}
            />
          </Modal>
        )}
      </WindowWrap>
    );
  }
}

class VacPlansEmpPlan extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this._isMounted = true;
    this.table = 18;
    this.ScreenName = 'VacPlans';
    this.state = {
      data: [],
      record: {},
      showempplan: false,
      NewEmpVacDays: [],
    };
    this.navigation = props.navigation;
  }

  componentDidMount() {}
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    let self = this;
    return (
      <WindowWrap>
        <EmpTimeTable
          depcode={global.userData.deplist.split(',').pop()}
          empcode={''}
          table={this}
        />
      </WindowWrap>
    );
  }
}

function VacPlans() {
  return (
    <Drawer.Navigator
      style={{background: 'white'}}
      screenOptions={{headerShown: false}}
      backBehavior={GetDefaultBackBehaviour()}
      drawerStyle={{display: 'none'}}
    >
      <Drawer.Screen
        name="VacPlansList"
        component={VacPlansList}
        options={{
          title: translate('VacPlans'),
        }}
      />
      <Drawer.Screen
        name="VacPlansEmpPlan"
        component={VacPlansEmpPlan}
        backBehavior={GetDefaultBackBehaviour()}
        options={{
          title: translate('VacPlanPlan'),
        }}
      />
      <Drawer.Screen
        name="VacPlansRecord"
        component={VacPlansRecord}
        backBehavior={GetDefaultBackBehaviour()}
        options={{
          title: translate('VacPlan'),
        }}
        getId={({params}) => params.id}
      />
    </Drawer.Navigator>
  );
}

export default VacPlans;
